export interface RoadmapStep {
  classId: number;
  title: string;
  desc: string;
  duration: string;
  level: "입문" | "중급" | "고급";
  icon: string;
  iconColor: string;
  points: number;
}

export interface RoadmapTrack {
  id: string;
  title: string;
  subtitle: string;
  emoji: string;
  color: string;
  lightBg: string;
  totalTime: string;
  skillTag: string;
  steps: RoadmapStep[];
}

export const roadmapTracks: RoadmapTrack[] = [
  {
    id: "visual",
    title: "AI 비주얼 크리에이터",
    subtitle: "이미지부터 영상까지, AI로 시각 콘텐츠 전문가 되기",
    emoji: "🎨",
    color: "#FF8C00",
    lightBg: "#FFF3E0",
    totalTime: "8시간",
    skillTag: "이미지 · 영상",
    steps: [
      {
        classId: 1,
        title: "미드저니 굿즈 만들기",
        desc: "AI 이미지로 스티커·굿즈 디자인 완성. kawaii 스타일 프롬프트 공식 마스터",
        duration: "2시간",
        level: "입문",
        icon: "ri-palette-line",
        iconColor: "#FF8C00",
        points: 150,
      },
      {
        classId: 6,
        title: "AI 숏폼 영상 만들기",
        desc: "런웨이+캡컷으로 릴스/쇼츠 완성. 정지 이미지를 움직이는 영상으로",
        duration: "2.5시간",
        level: "중급",
        icon: "ri-movie-2-line",
        iconColor: "#F9A825",
        points: 180,
      },
      {
        classId: 4,
        title: "스테이블 디퓨전 완전 정복",
        desc: "Positive/Negative Prompt 심화 + CFG Scale 제어로 영화 퀄리티 이미지",
        duration: "4시간",
        level: "고급",
        icon: "ri-camera-3-line",
        iconColor: "#7C3AED",
        points: 250,
      },
    ],
  },
  {
    id: "content",
    title: "AI 라이팅 & 마케팅",
    subtitle: "글쓰기·카피·프레젠테이션, AI로 콘텐츠 생산력 10배 높이기",
    emoji: "✍️",
    color: "#E91E63",
    lightBg: "#FCE4EC",
    totalTime: "6.5시간",
    skillTag: "글쓰기 · 마케팅",
    steps: [
      {
        classId: 3,
        title: "AI로 유튜브 스크립트 쓰기",
        desc: "AIDA 구조 + 7초 훅 작성법. 조회수 터지는 스크립트 공식",
        duration: "1.5시간",
        level: "입문",
        icon: "ri-video-line",
        iconColor: "#E91E63",
        points: 120,
      },
      {
        classId: 7,
        title: "AI 카피라이팅 부트캠프",
        desc: "타겟·채널·톤 3요소 설정으로 전환율 높이는 마케팅 문구 완성",
        duration: "2시간",
        level: "중급",
        icon: "ri-edit-2-line",
        iconColor: "#9C27B0",
        points: 160,
      },
      {
        classId: 8,
        title: "AI 프레젠테이션 마스터",
        desc: "Gamma AI 목차 프롬프트로 10분 만에 전문가급 PT 완성",
        duration: "3시간",
        level: "중급",
        icon: "ri-bar-chart-2-line",
        iconColor: "#2E7D32",
        points: 200,
      },
    ],
  },
  {
    id: "business",
    title: "AI 업무 자동화 & 개발",
    subtitle: "반복 업무를 없애고 AI 서비스까지 만드는 실무 커리큘럼",
    emoji: "⚙️",
    color: "#1565C0",
    lightBg: "#E3F2FD",
    totalTime: "6.5시간",
    skillTag: "업무 · 개발",
    steps: [
      {
        classId: 2,
        title: "업무 자동화 프롬프트",
        desc: "Act as 공식 + 출력 형식 지정. 주간 보고서·이메일 자동화",
        duration: "3시간",
        level: "입문",
        icon: "ri-flashlight-line",
        iconColor: "#00D873",
        points: 150,
      },
      {
        classId: 5,
        title: "GPT API로 챗봇 만들기",
        desc: "System Prompt 설계법 + API 연동. 코딩 몰라도 나만의 챗봇 완성",
        duration: "3.5시간",
        level: "중급",
        icon: "ri-robot-2-line",
        iconColor: "#1565C0",
        points: 220,
      },
    ],
  },
];

export const roadmapFAQs = [
  {
    q: "트랙 순서를 반드시 지켜야 하나요?",
    a: "순서대로 들으면 이전 수업 내용이 다음 수업에 연결되어 학습 효율이 높아져요. 하지만 강제는 아니니 관심 있는 클래스부터 시작해도 괜찮아요.",
  },
  {
    q: "트랙을 완료하면 어떤 혜택이 있나요?",
    a: "트랙 완료 시 전용 배지와 보너스 Grow Points 300P가 지급돼요. 완료 인증서도 발급되어 포트폴리오에 활용할 수 있어요.",
  },
  {
    q: "여러 트랙을 동시에 진행할 수 있나요?",
    a: "물론이에요! 본인 페이스에 맞게 여러 트랙을 병행할 수 있어요. 대시보드에서 각 트랙 진행 현황을 한눈에 확인할 수 있어요.",
  },
];
